import React from "react";
import { ProgressIndicator } from "ui-components";
import { Grid, Container, Row, Column } from "ui-grid";
import { translate } from "../../../i18n/translate";
import automationTestingLocators from "../../../screens/new/utils/automation-testing-locators.json";

interface PaymentFlowMobileCheckPayProgressIndicatorProps {
  currentPosition?: number;
}
export const PaymentFlowMobileCheckPayProgressIndicator = ({
  currentPosition,
}: PaymentFlowMobileCheckPayProgressIndicatorProps) => {
  return (
    <Grid>
      <Container>
        <Row>
          <Column span={{ xs: false, sm: 2, md: 2.5, lg: 1.5 }} />
          <Column span={{ xs: 12, sm: 8, md: 7, lg: 9 }}>
            <ProgressIndicator
              stepCount={2}
              currentPosition={currentPosition}
              labels={[
                translate(
                  "paymentFlow.paymentMethodMobileCheckPay.progressTitle.checkDetails"
                ) as string,
                translate(
                  "paymentFlow.paymentMethodMobileCheckPay.progressTitle.summary"
                ) as string,
              ]}
              {...automationTestingLocators.paymentFlowPaymentMethodMobileCheckPayProcessing
                .progressIndicator}
            />
          </Column>
        </Row>
      </Container>
    </Grid>
  );
};
